import React from 'react'
import { Head, Link, useForm } from '@inertiajs/react'
import { Container, Typography, Box, Button } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import GroupForm from './Form'

interface Company {
  id: number
  name: string
}

interface Props {
  companies: Company[]
}

export default function NewGroup({ companies }: Props) {
  const { data, setData, post, processing, errors } = useForm({
    name: '',
    company_id: '',
    gender: '',
    group_type: '',
    description: '',
    members_attributes: [] as { name: string; stage_name: string }[],
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post('/groups', { data: { group: data } })
  }

  return (
    <>
      <Head title="New Group" />
      <Container maxWidth="md" sx={{ py: 5 }}>
        <Box sx={{ mb: 4 }}>
          <Button
            component={Link}
            href="/groups"
            startIcon={<ArrowBackIcon />}
            sx={{ mb: 2 }}
          >
            Back to Groups
          </Button>
          <Typography variant="h5">New Group</Typography>
        </Box>

        <GroupForm
          data={data}
          setData={setData}
          errors={errors as Record<string, string[]>}
          companies={companies}
          processing={processing}
          onSubmit={handleSubmit}
          submitLabel="Create Group"
        />
      </Container>
    </>
  )
}
